import { render, staticRenderFns } from "./CalculatePopover.vue?vue&type=template&id=2501f8c4&"
import script from "./CalculatePopover.vue?vue&type=script&lang=js&"
export * from "./CalculatePopover.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports